const moment = require('moment');

export function utcTimetoLocalTimeWithzone(time) {
  const utcTimeString = time;
  const utcTime = new Date(utcTimeString);

  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // Convert UTC time to local time with the user's timezone
  const localTime = utcTime.toLocaleString("en-US", { timeZone: userTimezone });

  // Format the local time using Moment.js
  const outputFormat = "ddd D MMM hh:mm:ss a";
  const convertedTime = moment(localTime).format(outputFormat);

  return convertedTime;
}


function getUserTimezone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

// export function utcToLocalDate(time) {
//   const userTimezone = getUserTimezone();
//   const localTime = new Date(time).toLocaleString("en-US", { timeZone: userTimezone });
//   return moment(localTime).format("DD-MM-YYYY");
// }

export function utcToLocalDate(time) {
  const date = new Date(time);
  const day = date.getDate().toString().padStart(2, "0"); // DD
  const month = date.toLocaleString("en-US", { month: "short" }).toUpperCase(); // MON
  return `${day} ${month}`;
}


export function utcToLocalTime(time) {
  const userTimezone = getUserTimezone();
  const localTime = new Date(time).toLocaleString("en-US", { timeZone: userTimezone });
  return moment(localTime).format("hh:mm A");
}


